<template>
  <form-panel
    :title="isEdit ? 'Editar oportunidad' : 'Nueva oportunidad'"
    width="short"
    @closePanel="onCloseModal">
    <opportunity-form
      :old="oldOpportunity"
      :customer="customer"/>
  </form-panel>
</template>

<script>
import formPanel from '@/components/_shared/form-panel'
import opportunityForm from '@/modules/opportunities/opportunities-form'

export default {
  name: 'OpportunitiesCreateView',
  components: {
    formPanel,
    opportunityForm
  },
  props: {
    old: {
      type: Object,
      default: null
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      oldOpportunity: null
    }
  },
  computed: {
    customer () {
      return this.$store.getters['customers/item']
    }
  },
  mounted () {
    if (this.isEdit) {
      this.oldOpportunity = this.old
    } else {
      this.oldOpportunity = null
    }
  },
  methods: {
    onCloseModal () {
      this.$emit('closeEdition', false)
      this.$store.dispatch('app/toggleOpportunityPanel')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/app/opportunities/opportunities-create-view.vue